import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { useEffect, useState } from "react";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import { editCell, getBuzzList } from "../../util/APIUtils";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

const options = {
  sortIndicator: true,
  hideSizePerPage: false,
  paginationSize: 3,
  hidePageListOnlyOnePage: false,
  clearSearch: true,
  alwaysShowAllBtns: true,
  withFirstAndLast: true,
};

export default function PymntHstryBody({
  data,
  open,
  toggle,
  selectedOption,
  contextMenuPosition,
  handleRightClick,
  currentRow,
}) {
  const cellButton = (cell, row, enumObject, rowIndex) => {
    return (
      <span>
        <Button
          className="btn btn-warning"
          id={"more" + rowIndex}
          onClick={(e) => handleRightClick(e, row)}
          style={{ marginLeft: "5px" }}
        >
          <i className="fa fa-ellipsis-v" />
        </Button>
      </span>
    );
  };
  return (
    <span>
      <Card>
        <CardBody>
          <BootstrapTable
            data={data}
            version="4"
            condensed={true}
            striped
            hover
            pagination
            search
            options={options}
            exportCSV
            csvFileName="payment_history.csv"
          >
            <TableHeaderColumn
              isKey
              dataField="id"
              export={false}
              hidden={true}
            >
              ID
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="invoiceNumber"
              csvHeader="Invoicee No."
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Invoice No.
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="billDate"
              csvHeader="billDate"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Bill Date
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="paymentDate"
              csvHeader="Payment Date"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
              dataFormat={(cell) => cell.substring(0, 10)}
            >
              Payment Date
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="amountPaid"
              csvHeader="amountPaid"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Amount Paid
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="remainingBalance"
              csvHeader="remainingBalance"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
              editable={true}
            >
              Balance
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="paymentType"
              csvHeader="paymentType"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Payment Type
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="referenceNumber"
              csvHeader="referenceNumber"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Reference No.
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="chequeNumber"
              csvHeader="chequeNumber"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Chq No.
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="chequeDate"
              csvHeader="chequeDate"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Cheq Date
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="chequeStatus"
              csvHeader="chequeStatus"
              filter={{ type: "TextFilter", delay: 1000 }}
              dataSort
              tdStyle={{ whiteSpace: "normal" }}
              thStyle={{ whiteSpace: "normal" }}
            >
              Chq Status
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="button"
              dataFormat={cellButton}
              hiddenOnInsert
              export={false}
            >
              Actions
            </TableHeaderColumn>
          </BootstrapTable>
        </CardBody>
      </Card>
      {open && (
        <Dropdown
          isOpen={open}
          toggle={() => toggle()}
          style={{
            position: "fixed",
            top: contextMenuPosition.y,
            left: contextMenuPosition.x,
          }}
        >
          <DropdownToggle
            tag="span"
            data-toggle="dropdown"
            aria-expanded={true}
          />
          <DropdownMenu>
            <DropdownItem
              onClick={() => selectedOption(1)}
              disabled={currentRow.paymentType != "CHEQUE"}
            >
              Cheque Return
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      )}
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/PymntHstryBody.js